import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateDeviceSignalDocument } from './create.generated';

export const useCreateDeviceSignal = (
  options: ApiOptions<typeof CreateDeviceSignalDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(CreateDeviceSignalDocument, {
    ...useNotifications(CreateDeviceSignalDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.device_signals.create_success'),
    }),
    ...options,
  });
};
